<template>
  <q-btn
    :dark="isDarkModeGlobal"
    flat
    color="primary"
    icon="help"
    dense
    @click="layout = true"
  >
    <q-tooltip>Explanation of various distance parameters</q-tooltip>
  </q-btn>

  <q-dialog
    :dark="isDarkModeGlobal"
    v-model="layout"
  >
    <q-card
      :dark="isDarkModeGlobal"
      style="width: 800px; max-width: 80vw;"
    >
      <q-card-section>
        <div class="text-h6">
          Explanation of various distance parameters
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-img
          class="logo shadow-1"
          :src="logoUrl"
          alt="Distance parameters"
          style="min-height: 500px;"
          fit="scale-down"
        />
      </q-card-section>

      <q-card-actions
        align="right"
        class="text-primary"
      >
        <q-btn
          flat
          label="OK"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import logoUrl from '../assets/Thickness_explanation_sm.png'
import { ref } from 'vue'
import {storeToRefs} from "pinia"
const calculatorStore = useCalculatorStore()
import {useCalculatorStore} from '../stores/calculator.store'
const {
  isDarkModeGlobal
} = storeToRefs(calculatorStore)
const layout = ref(false)
</script>

